<template>
  <section>
    <b-row >
      <b-col class="box-effect linear"
        >
            <b-card 
              >   
                <template v-slot:header >
                  <div class="header-card">
                    Archivo plano de aportes registrados
                    <div class="float-right">
                      <b-button
                        variant="warning"
                        @click="updateGlobal({state: 'openModal/modal/modal',data: 'Quitar'});updateGlobal({state: 'openModal/modal/value',data: true });updateGlobal({state: 'openModal/modal/title',data: 'Quitar # planilla' })"
                      >Quitar # planilla</b-button>
                    </div>
                  </div> 
                </template> 
                <sw-tableget 
                    :tableItems="tableGBItems"
                    :tableSearch="tableGBSearch"
                    :tableOptions="tableGBoptions"
                    :warningClass="warningClass"
                    name="tableGetArchivo"
                    @filtrar="getFiltrar"
                    @limpiar="getLimpiar"
                    @save="saveForm"
                    >    
                    <template v-slot:filtrar>
                      <b-row style="margin-bottom:5px ;background: rgba(0, 80, 166, 0.03); 
                      ;padding-top:15px;border: 1px ridge;">
                        <b-col :md="4">                                        
                          <b-input-group  class="filter-sw-group" size="sm" prepend="Razón Social">
                            <c-multiselect
                              style="display:inline-block;flex: 1 1 0%"   
                              v-model="filter.id_datos_razon"                   
                              :options="filterSelects('datos_razon')"
                              @input="resetDataGet()"
                              label="name"
                              track-by="name"
                              :allow-empty="false"
                              :preselect-first="false"
                              :searchable="true"
                              placeholder="Seleccionar"
                              >
                              </c-multiselect>
                          </b-input-group>  
                          <div>         
                            <b-input-group class="filter-sw-group" size="sm" prepend="Periodo:" style="margin-bottom:5px">
                              <c-multiselect
                                style="display:inline-block;flex: 1 1 0%"   
                                v-model="filter.id_list_mes"                   
                                :options="lists.list_mes"
                                @input="changeBeetwen"
                                :allow-empty="false"
                                label="name"
                                track-by="name"
                                :preselect-first="false"
                                :searchable="true"
                                placeholder="Mes"
                                >
                              </c-multiselect>
                              <c-multiselect
                                style="display:inline-block;flex: 1 1 0%"   
                                v-model="filter.id_list_ano"                   
                                :options="lists.list_ano"
                                @input="changeBeetwen"
                                :allow-empty="false"
                                label="name"
                                track-by="name"
                                :preselect-first="false"
                                :searchable="true"
                                placeholder="Año"
                                >
                              </c-multiselect>
                            </b-input-group> 
                          </div>                                          
                        </b-col>        
                        <b-col :md="4">                     
                          <b-input-group class="filter-sw-group" size="sm" prepend="Desde:" style="margin-bottom:5px">
                            <input type="date" v-model="filter.inicial"  @input="resetDataGet()">
                          </b-input-group>  
                          <b-input-group class="filter-sw-group" style="margin-top:20px" size="sm" prepend="Hasta :" >
                            <input type="date" v-model="filter.final"  @input="resetDataGet()">
                          </b-input-group>     
                        </b-col>
                        <b-col :md="4">                       
                            <b-form-checkbox-group id="checkbox-group-2" size="md" v-model="filter.servicios" name="flavour-2">
                              <b-form-checkbox value="Ccf" @input="resetDataGet()">CCF</b-form-checkbox>
                              <b-form-checkbox value="Afp" @input="resetDataGet()">AFP</b-form-checkbox>
                            </b-form-checkbox-group>
                              <b-form-radio-group
                                @input="resetDataGet()"
                                v-model="filter.planilla"
                                :options="[{text: 'Sin No planilla', value: {compare: '=', value: null}},{text: 'Ya guardados', value: {compare: '<>', value: null}}]"
                                name="radio-inline"
                              ></b-form-radio-group>
                            <b-form-checkbox v-model="filter.prioridad" @input="resetDataGet()">Prioridad</b-form-checkbox>
                            <b-form-checkbox v-model="filter.sinPrioridad" @input="resetDataGet()">Sin prioridad</b-form-checkbox>
                        </b-col>
                      </b-row>                      
                    </template>                       
                    <template v-slot:modal>
                      <sw-modalanularregistro 
                        v-if="openModal.modal.modal==='Anular'"
                        @save="saveForm">
                      </sw-modalanularregistro>
                    </template>   
                </sw-tableget>  
            </b-card>           
      </b-col>      
    </b-row> 
    <b-modal 
      v-model="openModal.modal.value"
      :title="openModal.modal.title" 
      :header-bg-variant="'primary'"
      header-text-variant="light"
      :hide-footer="true"  
      :no-close-on-backdrop="true" 
      size="md" 
      >        
        <sw-modalregistrarplanilla 
          :prioridad="filter.prioridad" 
          v-if="openModal.modal.modal==='Planilla'"
          @save="saveForm"                     
          />    
        <SwModalQuitarPlanilla
          v-if="openModal.modal.modal==='Quitar'"
          @save="saveForm"                     
          />
    </b-modal> 
  </section>
</template>

<script>
import indexMix    from './indexMix.js'
import storeMix    from './storeMix.js'
import tableMix    from './tableMix.js'
import saveMix     from './saveMix.js'
import saveMixins  from '@/mixings/save.js'
import SwTableget from '@/components/dataTable/tableGet.vue'
import SwSearchs from '@/components/forms/searchs.vue'
import SwModalregistrarplanilla from '@/components/modals/registrarPlanilla.vue'
import SwModalQuitarPlanilla from '@/components/modals/Aportes/quitarPlanilla.vue'
import Multiselect from 'vue-multiselect'

export default {
  name: "afiliacion_informes",
  components: { 
    SwTableget,
    SwSearchs,
    'c-multiselect': Multiselect,
    SwModalregistrarplanilla,
    SwModalQuitarPlanilla
  },
  mixins: [indexMix, storeMix, tableMix, saveMix, saveMixins,],
};
</script>
